module.exports = __webpack_public_path__ + "img/evollu-logo.b1e68830.svg";